import * as React from 'react';

import { fromJson } from '@bufbuild/protobuf';
import {
  TruckEvent,
  TruckEventSchema,
} from '@rematter/frontend-lib-api-client/grpc/transportation/v1/truck_events_pb';
import { Col, EventDetailContainer, JsonViewer } from '@rematter/ui-web';

import { TruckCreatedDetail } from './TruckCreatedDetail';
import { TruckDeletedDetail } from './TruckDeletedDetail';
import { TruckUpdatedDetail } from './TruckUpdatedDetail';

type TruckEventDetailProps = {
  payload: string;
};

export const TruckEventDetail = ({ payload }: TruckEventDetailProps) => {
  const [showJson, setShowJson] = React.useState(false);

  const event = React.useMemo((): TruckEvent | null => {
    try {
      return fromJson(TruckEventSchema, JSON.parse(payload));
    } catch {
      return null;
    }
  }, [payload]);

  if (!event) {
    return <JsonViewer data={payload} title="Raw Payload (Parse Error)" />;
  }

  const { event: inner } = event;

  const renderEventContent = () => {
    switch (inner.case) {
      case 'created':
        return <TruckCreatedDetail event={inner.value} />;
      case 'updated':
        return <TruckUpdatedDetail event={inner.value} />;
      case 'deleted':
        return <TruckDeletedDetail event={inner.value} />;
      case undefined:
        return <JsonViewer data={payload} title="Unknown Event Type" />;
    }
  };

  const getEventTitle = (): string => {
    switch (inner.case) {
      case 'created':
        return 'Truck Created';
      case 'updated':
        return 'Truck Updated';
      case 'deleted':
        return 'Truck Deleted';
      case undefined:
      default:
        return 'Unknown Event';
    }
  };

  return (
    <Col className="@TruckEventDetail flex-1">
      <EventDetailContainer
        title={getEventTitle()}
        showJson={showJson}
        onToggleJson={() => setShowJson(!showJson)}
        jsonContent={payload}
      >
        {renderEventContent()}
      </EventDetailContainer>
    </Col>
  );
};
